var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_20134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90169 1.11332H5.56836V2.27999L4.62169 3.22666L5.03836 3.64332L6.23503 2.44999L6.23169 2.44666H6.23503V0.446655H2.23503V0.836655L2.90169 1.50332V1.11332Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935027 0.479989L0.465027 0.949989L3.43169 3.91666L2.23503 5.11332L2.23836 5.11666H2.23503V7.11332H6.23503V6.72332L7.06503 7.55332L7.53503 7.08332L0.935027 0.479989ZM5.56836 6.44666H2.90169V5.27999L3.84836 4.33332L5.56836 6.05666V6.44666Z",
    fill: "#A0A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_20134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.27e259f3eb81ba8e13362ddb9593ef59.svg";
export { ForwardRef as ReactComponent };